import React from 'react';

import type { MultiWidgetStateStore, PluginApp } from '@typings/plugin-runtime.ts';
import { StateObjMultiple } from '@utils/stateObj.ts';

import { widgetEnum } from '../../../utils/constants.ts';
import MapCompass from './MapCompassView.tsx';

const MAP_COMPASS_ID = 'mapCompass';
const DEFAULT_BEARING = 0;

type BearingPayload = {
  bearing: number;
};

type MapCompassState = {
  bearing: number;
};

function create(app: PluginApp) {
  const init = () => {};

  const widgetState: MultiWidgetStateStore<MapCompassState> = new StateObjMultiple<MapCompassState>({
    bearing: DEFAULT_BEARING,
  });

  const handleMapResetButtonClick = () => {
    app.bus.send('map/resetBearing');
  };

  app.bus.send('layers/register', {
    id: MAP_COMPASS_ID,
    widget: () => (
      <MapCompass
        isDesktop={app.env.isDesktop()}
        handleMapResetButtonClick={handleMapResetButtonClick}
        widgetState={widgetState}
        T={app.gt()}
      />
    ),
    show: true,
    isOverlay: true,
    layoutId: 'buttonOptions',
    widgetType: widgetEnum.Desktop,
    order: 10,
  });

  app.bus.on<BearingPayload>('map/userMoving', ({ bearing }) => {
    widgetState.update({ bearing });
  });

  app.bus.on<BearingPayload>('map/moveEnd', ({ bearing }) => {
    widgetState.update({ bearing });
  });

  return {
    init,
  };
}

export { create };
